"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paths = void 0;
const UserRequestPaths = {
    submitUserRequest: (userUuid) => `/v1/users/${userUuid}/requests`,
};
exports.Paths = {
    v1: Object.assign({}, UserRequestPaths),
};
